//  /////////////// COPYRIGHT © 2025/2026 IROÏD/DSTRKT™ FOR TIXFORGIGS
//  ////////////////////////////////////////////// ALL RIGHTS RESERVED
//  /////// LICENSED UNDER THE IROÏD LICENSE VERSION 1.0 [THE LICENSE]
//  /////// DO NOT USE THIS FILE EXCEPT IN COMPLIANCE WITH THE LICENSE
//
//  TixforGigs™ Unified API
//
//  VERSION: 4.6
//  PACKAGE: 4.6.297-SNAPSHOT
//  CONTACT: developer@tixforgigs.com
//  CREATED: 2026-02-26T01:20:10.489677Z
//
//  /////////////////////////////////////// AUTOGENERATED. DO NOT EDIT

@file:Suppress(
  "ArrayInDataClass",
  "EnumEntryName",
  "RemoveRedundantQualifierName",
  "UnusedImport"
)

package com.tixforgigs.apax.models


        import kotlinx.serialization.*

/**
* The filter types enum
*
* 
*  * ARTIST value: ARTIST - artist type 
*  * EVENT value: EVENT - event type 
*  * VENUE value: VENUE - venue type 
*  * GENRE value: GENRE - genre type 
*/
@Serializable
enum class FilterSearchType(val value: kotlin.String) {

    @SerialName(value = "ARTIST")
    ARTIST("ARTIST"),

    @SerialName(value = "EVENT")
    EVENT("EVENT"),

    @SerialName(value = "VENUE")
    VENUE("VENUE"),

    @SerialName(value = "GENRE")
    GENRE("GENRE");

  /**
  * Override [toString()] to avoid using the enum variable name as the value, and instead use
  * the actual value defined in the API spec file.
  *
  * This solves a problem when the variable name and its value are different, and ensures that
  * the client sends the correct enum values to the server always.
  */
  override fun toString(): kotlin.String = value

  companion object {
    /**
    * Converts the provided [data] to a [String] on success, null otherwise.
    */
    fun encode(data: kotlin.Any?): kotlin.String? = if (data is FilterSearchType) "$data" else null

    /**
    * Returns a valid [FilterSearchType] for [data], null otherwise.
    */
    fun decode(data: kotlin.Any?): FilterSearchType? = data?.let {
      val normalizedData = "$it".lowercase()
      values().firstOrNull { value ->
        it == value || normalizedData == "$value".lowercase()
      }
    }
  }
}

